import React, { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Loader2 } from "lucide-react";

export default function SSOCallbackPage() {
  const [searchParams] = useSearchParams();
  const { exchangeSSOTicket } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const ticket = searchParams.get("ticket") || searchParams.get("sso");
    if (ticket) {
      exchangeSSOTicket(ticket).finally(() => {
        navigate("/", { replace: true });
      });
    } else {
      navigate("/", { replace: true });
    }
  }, [searchParams, exchangeSSOTicket, navigate]);

  return (
    <div className="min-h-screen bg-[#0A0A0B] text-white flex items-center justify-center p-4">
      <div className="text-center space-y-4">
        <Loader2 className="w-8 h-8 text-[#FF8C69] animate-spin mx-auto" />
        <p className="text-sm text-[#A1A1AA]">Carregando...</p>
      </div>
    </div>
  );
}
